import axiosInstance from './axiosInstance';

export const getAllNotices = () => axiosInstance.get("/Notice/GetAllNotices");
export const createNotice = (request) => axiosInstance.post("/Notice/CreateNotice", request);
export const updateNotice = (request) => axiosInstance.put("/Notice/UpdateNotice", request);
export const deleteNotice = (noticeId) => axiosInstance.delete(`/Notice/DeleteNotice?noticeId=${noticeId}`);
export const togglePin = (noticeId) => axiosInstance.put(`/Notice/TogglePin?noticeId=${noticeId}`);

export const uploadNoticeImage = (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axiosInstance.post("/Notice/UploadImage", formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};
